module.exports = __webpack_public_path__ + "assets/Equidistant2Detailed.bb0cbd1b1e51276a38852e2f5bf2dd4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Equidistant2Detailed.png
// module id = 505
// module chunks = 0